import { useState } from "react";
import { Modal, Row, Form, Col, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import toastService from "../../_services/toastService";
import MessageModal from "../_components/MessageModal";
import SatAPI from "../../_services/sat";

const api = SatAPI();

function RemoveModal({ data = {}, hideModal }) {
  const snapshot = useSelector(state => state.snapshot.fileName);

  const [messageModal, setMessageModal] = useState(null);

  const openMessageModal = (title, message) => {
    setMessageModal(
      <MessageModal
        hideModal={() => setMessageModal(null)}
        title={title}
        message={message}
        icon="fas fa-exclamation-triangle"
      />
    );
  };

  const onFormSubmit = async e => {
    e.preventDefault();

    const allProgrammes = await api.getProgrammes(snapshot);
    const linkedProgrammes = allProgrammes.filter(p => p.clusterProgrammeId === data.ID);

    if (linkedProgrammes.length > 0) {
      openMessageModal(
        "Gekoppelde opleidingen bestaan nog",
        "Er zijn nog opleidingen gekoppeld aan deze cluster. Ontkoppel of verwijder deze opleidingen eerst."
      );
      return;
    }

    const allocations = await api.getBudgetSourceAllocations(snapshot);
    const activeAllocations = allocations.filter(a => a.programmeID === data.ID && a.amountFTE && a.amountFTE !== 0);

    if (activeAllocations.length > 0) {
      const budgetSources = await api.getBudgetSources(snapshot);
      const sourceNameById = new Map(budgetSources.map(s => [s.ID, s.name]));
      const sourceNames = [...new Set(activeAllocations.map(a => sourceNameById.get(a.budgetSourceID) || `Budgetbron #${a.budgetSourceID}`))];
      openMessageModal(
        "Opleiding kan niet verwijderd worden",
        `Deze opleiding heeft nog VTE toegewezen op de pagina Contingentverdeling vanuit ${sourceNames.length === 1 ? 'de volgende budgetbron' : 'de volgende budgetbronnen'}: ${sourceNames.join(', ')}. Ga naar Contingentverdeling, maak de cellen voor deze opleiding leeg, klik op Opslaan en probeer dan opnieuw te verwijderen.`
      );
      return;
    }

    try {
      let resp;
      if (data.ID) {
        resp = await api.deleteProgramme(data.ID);
      }
      console.log(resp);

      //api.createSnapshot();
      toastService.send({ title: "Verwijderd", message: "Opleiding is verwijderd" });
      hideModal();
    } catch (error) {
      //console.log(error);
      toastService.send({ title: "An error occured", message: "Kan opleiding niet verwijderen, verwijder eerst alle onderliggende objecten" });
      hideModal();
    }
  };
  return (
    <Modal
      show
      onHide={() => {
        hideModal();
      }}
      backdrop="static"
      keyboard={false}
      centered
      size="lg">
      {messageModal}
      <Modal.Header closeButton>
        <Modal.Title>Opleiding verwijderen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <Form onSubmit={onFormSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Ben je zeker dat je de opleiding <span className="font-bold">{data.name}</span> wilt verwijderen?</Form.Label>
              </Form.Group>

              <Button variant="danger" type="submit" disabled={snapshot}>
                <span>
                  <i className="far fa-trash" />
                  &nbsp;Verwijder
                </span>
              </Button>
            </Form>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

export default RemoveModal;
